// extracted by mini-css-extract-plugin
export default {"container":"EstimateTemplateService_container__j10UD","item":"EstimateTemplateService_item__6oKIr","closeField":"EstimateTemplateService_closeField__MmOM8"};